import React, { FC } from 'react';
import { ConfigProvider } from 'antd';
import styled from 'styled-components';
import { useGetValidationJs } from '~/controllers/validation';
import { Scrollbars } from '~/components';
import TotalPriceMobileModule from '~/components/TotalPriceMobileModule';
import { getLayoutHeight, useHeaderHeight } from '~/hooks/useHeaderHeight';
import { useDirection } from '~/hooks/i18nHooks';
import { getDecodedJwt } from '~/utils/getDecodedJwt';
import { auth } from '~/api/auth';
import Header from './Header';
import WizardContentContainer from './WizardContentContainer';
import WizardTopNavigation from './WizardTopNavigation';
import CardHolderTopNavigation from './CardHolderTopNavigation';

const WizardLayout: FC = (props) => {
  const { children } = props;
  useGetValidationJs();
  const dir = useDirection();

  const decodeToken = getDecodedJwt();

  // TODO: Cardholder role check will do as part of integration
  // const role = ['cardholder']; // Change the value here........
  const roles = decodeToken?.realm_access?.roles;
  const isCardholder = (roles || []).includes('CARD_HOLDER');

  const headerHeight = useHeaderHeight({ wizardHeader: true });

  const { invitationType }: any = getDecodedJwt();
  const isInvitationTypeCardHolder: any =
    invitationType === 'CARD_HOLDER' || auth.getInvitationType() === 'CARD_HOLDER';

  return (
    <ConfigProvider componentSize="large">
      <Container className="WizardLayout">
        <Header
          middleContent={
            isCardholder && isInvitationTypeCardHolder ? <CardHolderTopNavigation /> : <WizardTopNavigation />
          }
          tabletContent={<TotalPriceMobileModule />}
        />
        <Scrollbars style={getLayoutHeight(headerHeight)}>
          <div className="WizardLayout-Wrapper" style={getLayoutHeight(headerHeight)} dir={dir}>
            <WizardContentContainer>{children}</WizardContentContainer>
          </div>
        </Scrollbars>
      </Container>
    </ConfigProvider>
  );
};

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 100vh;

  .WizardLayout-Wrapper {
    display: flex;
    flex: 1;
    justify-content: center;
    background-color: #f2f5f7;
  }
`;

export default WizardLayout;
